import { BASIC_LPTOKENS_FOR_ROUTE_PATH_SHIBUYA } from './shibuya';
import { BASIC_LPTOKENS_FOR_ROUTE_PATH_SHIDEN } from './shiden';
import { ChainIdByLPTokens } from './types';

export const BASIC_LPTOKENS_FOR_ROUTE_PATH: ChainIdByLPTokens = {
  ...BASIC_LPTOKENS_FOR_ROUTE_PATH_SHIBUYA,
  ...BASIC_LPTOKENS_FOR_ROUTE_PATH_SHIDEN
}
